<template>
    <div :class="background">
        <div :class="containerClass()">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            background: {
                type: String,
                default: 'bg-transparent'
            },
            size: {
                type: String,
                default: 'default'
            },
            containerClasses: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        },

        methods: {
            containerClass() {
                const map = {
                    'default': 'container',
                    'lg': 'container-lg'
                };
                let className = map[this.size];
                let result = {};
                result[className] = true;
                this.containerClasses.forEach(c => result[c] = true);
                return result;
            }
        }
    }
</script>
